import { path } from 'ramda';

import { useUserSelector } from 'js/store/hooks';

export const useIsVipLevel = () => {
    const vipLevel = useUserSelector(path(['userDetails', 'vipLevel']));

    return Number(vipLevel) >= 23;
};
